<template>
  <div>
    <div class='updataStyle'>
         <!--上传文件-->
        <div>
            <Upload
                multiple
                ref="upload"
                :format="['xls','xlsx']"
                :max-size="5000"
                :before-upload="handleUpload"
                :data="updateQuery"
                :action=updateUrl
            >
            <div>
                <div>
                    <Button icon="ios-cloud-upload-outline">上传Excel文件</Button>
                </div>
                <p style="padding:5px 0">支持.xls,.xlsx格式文件上传</p>
            </div>
            </Upload>
        </div>
        <!--上传文件按钮-->
        <div>
            <ul class="file-list" v-show="showName">
                <li>文件名: <span style="font-size:15px;">{{ fileName }}</span>
                    <Icon type="ios-close" size="20" style="float:right;" @click="delFileList"></Icon>
                </li>
            </ul>
        </div>
        <!--文件上传按钮-->
        <div v-show="islook"  class='updataStyle1'>
            <Button type="primary" :loading="loading" icon="ios-power" @click="upload">
                <span v-if="!loading">上传文件</span>
                <span v-else>正在上传文件中...</span>
            </Button>

        </div>
    <button type="primary" @click="back" style="border-radius: 5px;padding:7px 10px;background:#8c0776;color:#fff;border:none;position:absolute;top:0px;left:375px"><Icon type="ios-arrow-back" style="margin-right:5px" />返回</button>
    <button type="primary" style="border-radius: 5px;padding:7px 10px;background:#8c0776;color:#fff;border:none;position:absolute;top:0px;left:270px" @click="download"><Icon type="md-archive" style="margin-right:5px"/>模板下载</button>
    </div>

  </div>
</template>
<script>
import SearchHeader from "../../components/SearchHeader";
import YnModal from "../../components/YnModal"
import { $getBrowerHeight,$formatDate } from "../../tools";

//获取excel上传接口
import { updateExcel } from "./../../http/customer";
import { baseURL } from "./../../config";

export default {
  components: { SearchHeader,YnModal},
  data() {
    return {
        updateUrl:`${ baseURL }lab-datacenter/customer/importSampleInfo`,
        updateQuery:{},
        showName:false,
        fileName:"",
        file: {},
        islook:true,
        loading:false,
        key:"",
        relationId:"",
        downloadUrl:""
    }
  },
  mounted() {
    //获取缓存值
    this.key= localStorage.getItem("data-center-token");
    this.relationId=this.$utils.getUrlKey("id");
  },
  methods: {
        //上传文件前
      handleUpload (file) {
        this.file=file;
        this.fileName=this.file.name;
        this.showName = true;
        this.islook= true;
        //console.log(this.file)
        const extension = file.name.split('.')[1] === 'xls'
        const extension2 = file.name.split('.')[1] === 'xlsx'
         if (!extension && !extension2) {
                this.$Message.warning('上传模板只能是 xls、xlsx格式!')
                this.file=null
                this.showName=false;
                return
            }
        return false;
      },
      //模板下载
      download(){
          this.downloadUrl=`${baseURL}common/common/downLoadFile?attachId=150570&fileName=上传模板&type=1`
          let anchor = document.createElement("a");
          anchor.href = this.downloadUrl;
          anchor.click();
      },
      //删除上传的文件
      delFileList(){
         this.file=null;
         this.showName=false;
         this.fileName='';
        //  console.log(this.file);
      },
      //上传函数
      upload(){
        let that = this;
        // console.log(this.file)
        if(this.fileName && this.file){
          that.loading2 = true;
          //创建 formData 对象
          let formData = new FormData();
          //向 formData 对象中添加文件
          formData.append('key', this.key);
          //单个文件上传
          formData.append('file', this.file);
          //Id上传
          formData.append('labId', this.relationId);
          let config = {
           headers: {
            'Content-Type': 'multipart/form-data'
           }
          }
          this.$axios.post("lab-datacenter/customer/importSampleInfo", formData).then(function (rdata) {
               if(rdata.data.code==0){
                that.loading2 = false;
                that.$Message.success('上传成功');
               }
              console.log(rdata)
              }).catch(function (error) {
                that.loading2 = false;
              });
        }else if(this.file==null){
          that.$Message.error("请上传一个.xls,.xlsx文件");
        }else{
          that.$Message.error("请至少上传一个文件");
        }
      },
     back(){
      this.$router.go(-1);
     }
  },

};
</script>
<style scoped>
.updataStyle{
    width:100%;
    position:relative
  }
.updataStyle1{
    width:150px;
    height:50px;
    display:inline-block;
    position:absolute;
    left:150px;
    top:0px;
}
</style>


// WEBPACK FOOTER //
// src/views/excel/excel.vue